import { useMemo } from 'react';
import { useCurrentUser } from '../api/UserApi';
import * as Constants from '../constants';

interface UserRole {
  role: number;
  isStudent: boolean;
  isTeacher: boolean;
  isAdmin: boolean;
  isOver18: boolean;
  isPaid: boolean;
}

export const useRole = () => {
  const { data: user, isLoading } = useCurrentUser();

  const userRole = useMemo<false | UserRole>(() => {
    if (!user) {
      return false;
    }
    return {
      role: user.user_role_id,
      isStudent: user.user_role_id === Constants.USER_ROLES.STUDENT,
      isTeacher: user.user_role_id === Constants.USER_ROLES.TEACHER,
      isAdmin: user.user_role_id === Constants.USER_ROLES.ADMIN,
      isOver18:
        user.user_role_id === Constants.USER_ROLES.STUDENT
          ? user.age && user.age >= 18
          : true,
      isPaid: user.access_level === Constants.USER_ACCESS_LEVELS.PAID,
    } as UserRole;
  }, [user]);

  return { userRole };
};
